import { Component, Input, OnInit, SimpleChanges, ViewChild, EventEmitter, Output } from '@angular/core';
import { MatSnackBar, MatDialog, MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AddCandidateModalComponent } from '../add-candidate-modal/add-candidate-modal.component';
import { EditCandidateModalComponent } from 'src/app/medical/edit-candidate-modal/edit-candidate-modal.component';
import { TestedIndividualService } from 'src/app/services/tested-individual.service';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { MedicalFromService } from 'src/app/services/medical-from.service';
import { saveAs } from "file-saver";
import { FilterService } from 'src/app/services/filter.service';
import { UtilityService } from '../../services/utility.service'
import { UserDocumentService } from '../../services/user-document.service';
@Component({
  selector: 'app-tested-individual',
  templateUrl: './tested-individual.component.html',
  styleUrls: ['./tested-individual.component.scss']
})
export class TestedIndividualComponent implements OnInit {
  jobId: any;
  displayedColumns: string[] = ['no', 'name', 'email', 'Action'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  candidates: any[];
  noDataMsg = {
    title: "No Candidates!",
    data: "You have not yet assigned any candidates"
  }
  isLoading: boolean = false
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  afterFilter: any;
  filterActive: Boolean = false;
  loading;
  user
  spinnerIndex: Number
  isSpinner: boolean = false
  @Input('jobId') jobFromClient;
  @Output() addNewLerner: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public _medicalFormService: MedicalFromService,
    public _filter: FilterService,
    public _encryptDescryptService: EncryptDecryptService,
    private router: Router,
    public _testedIndividualService: TestedIndividualService,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public activatedRoute: ActivatedRoute,
    public _mpJobService: MpjobService,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService
  ) {
    this.dataSource = new MatTableDataSource(this.candidates);
  }

  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.user && this.user.isClient) {
      this.displayedColumns = ['no', 'name', 'email'];
    }
    this.loading = true
    this.activatedRoute.params.subscribe(params => {
      console.log("Params", params)
      if (params.jobid) {
        this.jobId = params.jobid
      }
    })
    this.getCandidates()
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobFromClient && changes.jobFromClient.currentValue) {
      this.jobId = changes.jobFromClient.currentValue
      this.getCandidates()
      // this.getCandidateMedicalStatus()
    }
  }

  add() {
    this.openDialog(AddCandidateModalComponent, { mpjob: this.jobId }).subscribe(res => {
      console.log('ADDED res when new medical user added i=======', res)
      if (res == undefined) return
      // let obj = {
      //   userId: res.testedIndividual._id,
      // }
      res.testedIndividual['userId'] = res.testedIndividual._id
      res.testedIndividual['userType'] = 'testedIndividual'
      res.testedIndividual['jobId'] = res.testedIndividual.mpJob
      this.addNewLerner.emit(res.testedIndividual)
      this.candidates.push(res.testedIndividual)
      this.updateData(this.candidates)
      console.log("this.candidates", this.candidates)
      this.handleSnackBar({ msg: "Candidate Added successfully!", button: "Ok" });
    })
  }


  downloadAllPDF() {
    console.log(" Call Download All PDF ")
    this.loading = true
    this._medicalFormService.downloadAllMedicalpdf(this.jobId)
      .subscribe(res => {
        console.log(" RES ", res)
        if (res && res.data && res.data.pdf) {
          const downloadLink = document.createElement("a");
          // let temp = res.zip.title.replace(/\s+/g, '_');
          // this.isSpinner = false
          // const fileName = title + ".zip";
          downloadLink.href = res.data.pdf;
          // downloadLink.download = fileName;
          downloadLink.click();
          this._utilityService.handleSnackBar({ msg: "All Form Zip File Download Successfully", button: "Ok" })
        } else {
          this._utilityService.handleSnackBar({ msg: "All Form Zip File Download Fail", button: "Ok" })
        }
        this.loading = false
      }, error => {
        console.error(" ERROR ", error)
        this.handleSnackBar({ msg: 'Something went wrong', button: "Ok" });
        this.loading = false
      })
  }






  editModal(index, data) {
    this.openDialog(AddCandidateModalComponent, data).subscribe(res => {
      if (res == undefined) return
      console.log('res', res)
      if (res.action == 'edit') {
        this.candidates.push(res.data)
        this.updateData(this.candidates)
      }
      else if (res.action == 'delete') {
        console.log("candidate to delete")
      }
      // this.getCandidates();
      this.handleSnackBar({ msg: "Candidate Edited successfully!", button: "Ok" });
    })
  }

  applyFilter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    if (searchText === '') {
      this.updateData(this.candidates);
      this.filterActive = false;
    }
    let filteredLearner = this._filter.filter(searchText, this.candidates, ['name']);
    this.updateData(filteredLearner);
    if (filteredLearner.length <= 0) {
      this.afterFilter = {
        title: "No Candidates!",
        data: "No candidates with matched search text found!"
      }
    }
  }




  // UTILITY 
  updateData(clients) {
    console.log("UPDATING DATA = ", clients)
    this.dataSource = new MatTableDataSource(clients);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data, width: '1000px' });
    return dialogRef.afterClosed();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }


  // REDIRECTION
  userProfile(user, formType) {
    console.log("user value ", user);

    if (this.user && !this.user.isClient) {

      let queryObj = {};

      if (user.userType == 'learner') {
        queryObj['isLearner'] = true;
        queryObj['isTestedIndividual'] = true;
        queryObj['jobId'] = user.jobId;
      } else {
        queryObj['isLearner'] = false;
        queryObj['isTestedIndividual'] = true;
        queryObj['jobId'] = user.jobId;
        // queryObj['formType'] = formType === 'medical' ? 'isMedical' : 'isBreath';
      }
      if (formType === 'medical') queryObj['formType'] = 'isMedical';
      if (formType === 'breath') queryObj['formType'] = 'isBreath';
      if (formType === 'poct') queryObj['formType'] = 'isPoct';
      console.log('Encrypted UserRole:', queryObj);

      this.router.navigate(['/learner/view/' + user.userId], { queryParams: queryObj, })
    }
  }

  // API

  getCandidates() {
    this._mpJobService.getAllCandidateList(this.jobId).subscribe(res => {
      console.log('res of all candidates', res)
      this.candidates = res
      this.loading = false
      this.updateData(res)
    })
  }

  downloadPdf(user, index) {
    console.log("Check index", index);

    this.isLoading = true
    this.spinnerIndex = index
    this.isSpinner = true
    console.log('download pdf userId:', user);
    this._utilityService.handleSnackBar({ msg: "Preparing Download!", button: "Ok" })
    let data = { userId: user.userId }
    // this.loading = true;
    this.isLoading = true;
    this._medicalFormService.downloadMedicalpdf(data).subscribe((res) => {
      this.saveToFileSystem(res, user);
      this._utilityService.handleSnackBar({ msg: "Download successfully!", button: "Ok" })
      this.isLoading = false
      this.isSpinner = false
    }, err => {
      this._utilityService.handleSnackBar({ msg: err.msg, button: "Ok" })
      this.isLoading = false
      this.isSpinner = false
    })
  }

  private saveToFileSystem(response, user) {
    let byteArray = new Uint8Array(response.data);
    let blob = new Blob([byteArray], { type: 'application/pdf' });
    // this.loading = false;
    this.isLoading = false;
    let temp = user.name.replace(/\s+/g, '_');
    saveAs(blob, temp);
  }


  downloadBreathAlcoholForm(user, index, type) {
    this.isLoading = true
    this.spinnerIndex = index
    this.isSpinner = true
    console.log('download pdf userId:', user);
    this._utilityService.handleSnackBar({ msg: "Preparing Download!", button: "Ok" })
    let data = { userId: user.userModelId, documentId: this.jobId, type: type }
    // this.loading = true;
    this.isLoading = true;
    this._userDocumentService.downloadBreathAlcoholForm(data).subscribe((res) => {
      console.log("RESPONSE OF DATA", res)
      if (res && res.bufferData) this.saveToFileSystem(res.bufferData, user);
      else {
        console.log("RES OF DATA", res)
        const downloadLink = document.createElement("a");
        downloadLink.href = res;
        downloadLink.download = user.name.replace(/\s+/g, '_')
        downloadLink.click()
      }
      this._utilityService.handleSnackBar({ msg: "Download successfully!", button: "Ok" })
      this.isLoading = false
      this.isSpinner = false
    }, err => {
      this._utilityService.handleSnackBar({ msg: err.msg, button: "Ok" })
      this.isLoading = false
      this.isSpinner = false
    })
  }

}
